module.exports = __webpack_public_path__ + "static/lake_aerial_1-d3a38668010271dbb55cb9aad29fcdf2.jpg";